import { NgModule } from "@angular/core";
import { AppCommonModule } from "../../common/app-common.module";
import { HeaderComponent } from "./header.component";

@NgModule({
  imports: [
    AppCommonModule
  ],
  declarations: [
    HeaderComponent
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule {}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.module.ts